import { absolutePathWithArrayIndices } from "../absolutePath";
import type { AnalyticsApiParams } from "./types";

export const live = {
  events_completed: (params: AnalyticsApiParams) =>
    absolutePathWithArrayIndices("analytics/live/events_completed", params),
  total_rsvps: (params: AnalyticsApiParams) =>
    absolutePathWithArrayIndices("analytics/live/total_rsvps", params),
  live_attendance: (params: AnalyticsApiParams) =>
    absolutePathWithArrayIndices("analytics/live/live_attendance", params),
  tickets_sold: (params: AnalyticsApiParams) =>
    absolutePathWithArrayIndices("analytics/live/tickets_sold", params),
  event_revenue: (params: AnalyticsApiParams) =>
    absolutePathWithArrayIndices("analytics/live/event_revenue", params),
  popular_times: (params: AnalyticsApiParams) =>
    absolutePathWithArrayIndices("analytics/live/popular_times", params),
  event_activity: (params: AnalyticsApiParams) =>
    absolutePathWithArrayIndices("analytics/live/event_activity", params),
  popular_events: (params: AnalyticsApiParams) =>
    absolutePathWithArrayIndices("analytics/live/popular_events", params),
  top_attendees: (params: AnalyticsApiParams) =>
    absolutePathWithArrayIndices("analytics/live/top_attendees", params),
};
